function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 4H2C1.2 4 .6 4.7.6 5.5S1.2 7 2 7h1v15.5c0 .8.7 1.5 1.5 1.5h12.9c.8 0 1.5-.7 1.5-1.5V7h1c.8 0 1.5-.7 1.5-1.5S20.8 4 20 4zM6 21V7h1.3v14H6zm4.3 0V7h1.5v14h-1.5zm4.4 0V7H16v14h-1.3zM15 3H7c-.8 0-1.4-.7-1.4-1.5S6.2 0 7 0h8c.8 0 1.5.7 1.5 1.5-.1.8-.7 1.5-1.5 1.5"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24"
  }, props), _ref);
};

export default SvgComponent;